if (!customElements.get('cart-form')) {
    class CartForm extends HTMLElement {
        static get observedAttributes() {
            return ['data-state'];
        }
        set dataState(value) {
            this.setAttribute('data-state', value);
        }
        get dataState() {
            return this.getAttribute('data-state');
        }
        attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'data-state') {
                switch (newValue){
                    case 'loading':
                        this.Loading()
                        break
                    case 'done': 
                        this.DoneLoading()
                        break
                    default:
                        break
                }
            }
        }
        Loading() {
            this.submitButton.disabled=true
        }
        DoneLoading(){
            this.submitButton.disabled=false
        }
        async onSubmitHandler(event){
            event.preventDefault();
            this.setAttribute('data-state', 'loading')

            try {
                const formData = new FormData(this.form)
                
                // Submit form with ajax
                const Result = await fetch("/cart/add", {
                    method: "post",
                    body: formData,
                });

                if(Result.ok) {
                    // Fetch New Cart Details
                    const res = await fetch("/cart.json");
                    const cart = await res.json();
        
                    // Update Cart Event
                    TriggerEvent('UpdateCart', cart)
                } else {
                    const Processed = await Result.text()
                    console.log('CartForm Error:', Processed)
                    // TODO BUILD NOTIFICATION SYSTEM / Process Cart Data into Notification Html
                    // TriggerEvent('Notification', ProcessCartNotification(cart))
                }
            } catch (e) {
                console.log('CartForm Error:', e)
                // TODO BUILD NOTIFICATION SYSTEM ERROR HANDLING
                // TriggerEvent('Notification', {data: default Notification data here})
            }
            finally {
                this.setAttribute('data-state', 'done')
            }
        }

        constructor() {
            super();
            this.form = this.querySelector('form');
            this.submitButton = this.querySelector('[type="submit"]');
            this.submitButton.disabled = false;
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
    }
    customElements.define('cart-form', CartForm);
}